import { api } from '../../../../services/api';
import { formatPrice } from '../../../../utils/formatPrice';

export async function cotacaoFrete({
  cubagem,
  numeroNota,
  cpfCnpj,
  cep,
  valorTotalItens,
  ie,
  qtdCaixas = 1,
  motoboy
}) {
  const params = {
    cubagem: cubagem,
    numero_nota: numeroNota,
    cpf_cnpj_cliente: cpfCnpj,
    cep_cliente: cep,
    valor_total_itens: valorTotalItens,
    inscricao_estadual: ie,
    quantidade_caixas: qtdCaixas,
    motoboy
  };

  const response = await api.post('/site/v2/cotacao-frete/simulacao-frete-transportadoras', params);

  const dataFormatted = {
    erro: response.data.transportadoras.erro,
    integradas: response.data.transportadoras.integradas.map((item) => {
      return {
        ...item,
        valor_frete: formatPrice(item.valor_frete),
        original_valor_frete: item.valor_frete,
        valor_total_frete_30: formatPrice(item.valor_total_frete_30),
        original_valor_total_frete_30: item.valor_total_frete_30,
        valor_imposto: formatPrice(item.valor_imposto),
        original_valor_imposto: item.valor_imposto
      };
    }),
    internas: response.data.transportadoras.internas.map((item) => {
      return {
        ...item,
        valor_frete: formatPrice(item.valor_frete),
        original_valor_frete: item.valor_frete,
        valor_total_frete_30: formatPrice(item.valor_total_frete_30),
        original_valor_total_frete_30: item.valor_total_frete_30,
        valor_imposto: formatPrice(item.valor_imposto),
        original_valor_imposto: item.valor_imposto
      };
    })
  };

  return dataFormatted;
}
